<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px">


            <el-form-item label="分类名称" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input v-model="formData.name" placeholder="分类名称"></el-input>
            </el-form-item>

            <el-form-item label="分类标识" prop="flag" :error="formErrorMsg.flag" class="fb-form-item">
                <el-input v-model="formData.flag" placeholder="分类标识"></el-input>
            </el-form-item>

            <el-form-item label="上级菜单" prop="parent" :error="formErrorMsg.parent" class="fb-form-item">
                <cms-category-select v-model="formData.parent"></cms-category-select>
            </el-form-item>

            <el-form-item label="简介" prop="description" :error="formErrorMsg.description" class="fb-form-item">
                <el-input type="textarea" v-model="formData.description" placeholder="简介"></el-input>
            </el-form-item>

            <el-form-item label="封面" prop="cover" :error="formErrorMsg.cover" class="fb-form-item">
                <single-pic-uploader v-model="formData.cover" category="CMS_CATEGORY_COVER"></single-pic-uploader>
            </el-form-item>

            <el-form-item label="排序" prop="sortNum" :error="formErrorMsg.sortNum" class="fb-form-item">
                <el-input v-model="formData.sortNum" placeholder="排序"></el-input>
            </el-form-item>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>

    import CmsCategorySelect from "../../components/CmsCategorySelect";
    import SinglePicUploader from "../../components/SinglePicUploader";
    export default {
        name: "CmsEdit",
        components: {SinglePicUploader, CmsCategorySelect},
        data() {
            return {
                api:{
                   update:this.$api.cmsCategory.update,
                   detail:this.$api.cmsCategory.detail,
                },
                formErrorMsg:{
                    name: '',
                    description: '',
                    parent:'',
                    sortNum:'',
                    flag:''
                },
                formData: {
                    code: '',
                    name: '',
                    description: '',
                    parent:'',
                    sortNum:'',
                    cover:'',
                    flag:''
                },
                rules: {
                    name: [
                        {required: true, message: '请输入分类名称', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.update,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });
                                });
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.detail,this.$qs.stringify(this.$route.query)).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){
                        vm.formData[fKey] = resp.data.data[key][fKey];
                    }
                }
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>


<style>

    .editor-item{
         position: relative;
    }

    .editor-item >.el-form-item__content{
        line-height: initial !important;
    }
</style>